import styled from 'styled-components';
import MapNav from './MapNav';
import { useEffect, useState } from 'react';
import { MapFilterType } from '../search/filter/SampleData';
import MapBox from './Map';
import FullRoadView from '../map/component/FullRoadView';
import { useMapFilterContext } from '../../context/MapFilterContext';
import NewMapService from '../../service/map/newMap';
import { useMapContext } from '../../context/MapContext';
import RegionModal from './components/regionModal/RegionModal';
import { useLocation } from 'react-router-dom';
import { isLogin } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';
import MapGuideButton from './components/guideButton/MapGuideButton';

const MapSearch = () => {
  const { modalDispatch } = useModal();

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  // const [isListModalOpen, setisListModalOpen] = useState(false);
  const [isSearchInputFocus, setIsSearchInputFocus] = useState(false);
  const { mapFilter, setMapFilter } = useMapContext();
  const [markerData, setMarkerData] = useState<any[]>([]);
  const {
    onFullRoadView,
    zoomLevel,
    regionModalOn,
    setRegionModalOn,
    setMarkerDetail,
  } = useMapFilterContext();
  const [bounds, setBounds] = useState({
    swLat: 0,
    swLng: 0,
    neLat: 0,
    neLng: 0,
  });

  const openFilterModal = () => {
    if (isFilterModalOpen) {
      setIsFilterModalOpen(false);
      return;
    }
    setIsFilterModalOpen(true);

    setMarkerDetail(null);
    setIsSearchInputFocus(false);
  };

  const closeFilterModal = () => {
    setIsFilterModalOpen(false);
  };

  useEffect(() => {
    if (isSearchInputFocus) {
      setIsFilterModalOpen(false);
      // setMarkerDetail(null);
    }
  }, [isSearchInputFocus]);

  const getMarkerList = async () => {
    if (!isLogin()) {
      modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
      return;
    }
    const result = await NewMapService.markerList({
      swLat: bounds.swLat,
      swLng: bounds.swLng,
      neLat: bounds.neLat,
      neLng: bounds.neLng,
      type: mapFilter.type,
      itemCode:
        mapFilter.multiItemStatus.join(',') === 'all'
          ? ''
          : mapFilter.multiItemStatus.join(','),
      status:
        mapFilter.progressStatus.join(',') === 'all'
          ? ''
          : mapFilter.progressStatus.join(','),
      specialCondition: mapFilter.specialItemCond,
      specialItems: mapFilter.specialItemCondition.join(','),
      zoomLevel: zoomLevel ?? 3,
      minPrice: mapFilter.minPrice,
      maxPrice: mapFilter.maxPrice,
      minSaleDate: mapFilter.minSaleDate,
      maxSaleDate: mapFilter.maxSaleDate,
      minBidCount: mapFilter.minBidCount,
      maxBidCount: mapFilter.maxBidCount,
    });
    setMarkerData(result.data);
  };

  useEffect(() => {
    if (
      bounds.swLat === 0 &&
      bounds.swLng === 0 &&
      bounds.neLat === 0 &&
      bounds.neLng === 0
    ) {
      return;
    }

    const func = async () => {
      // setListData([]);
      setMarkerData([]);
      getMarkerList();
      // getList();
      // getMarkerList();
      // getList();
    };
    func();
  }, [mapFilter, bounds]);

  return (
    <Container>
      <MapContainer>
        <StyledMapNavWrapper>
          <MapNav
            filterVisible={isFilterModalOpen}
            openFilterModal={openFilterModal}
            closeFilterModal={closeFilterModal}
            isFocus={isSearchInputFocus}
            setIsFocus={setIsSearchInputFocus}
          />

          <MapGuideButton />
        </StyledMapNavWrapper>
        <ContentWrapper>
          <MapBox
            markerData={markerData}
            bounds={bounds}
            setBounds={setBounds}
            getMarkerList={getMarkerList}
          />
        </ContentWrapper>
        {onFullRoadView && <FullRoadView />}
      </MapContainer>
    </Container>
  );
};

export default MapSearch;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  max-width: 900px;
  margin: 0 auto;
`;

const ContentWrapper = styled.div`
  width: 100vw;
  height: 100dvh;
  display: flex;
  max-width: 900px;
`;

const MapContainer = styled.div`
  width: 100%;
  max-width: 900px;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  // overflow-y: hidden;
`;

const StyledMapNavWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2001;
`;
